<script>
import { mapState } from 'vuex'
import { GeneralForm } from '@src/forms/Property'
import Request from '@src/mixins/request'

export default {
  mixins: [Request],

  data() {
    return {
      form: {},
    }
  },

  computed: {
    ...mapState('app', ['currentProperty']),
  },

  mounted() {
    this.form = new GeneralForm(this.$route.params.property)
  },

  methods: {
    onSubmit() {
      this.updateData({
        url: this.endpoint.property.updateGeneral,
        data: {
          id: this.currentProperty.id,
          update: this.form,
        },
      })
    },
  },
}
</script>

<template>
  <VForm @submit.prevent="onSubmit">
    <BaseCard>
      <BaseControlInput label="Name">
        <VTextField v-model="form.name" label="Name" color="gold" />
      </BaseControlInput>

      <BaseControlInput label="Description">
        <VTextarea
          v-model="form.description"
          label="Description"
          color="gold"
        />
      </BaseControlInput>

      <BaseControlInput label="Address">
        <VTextField v-model="form.address" label="Address" color="gold" />
      </BaseControlInput>

      <BaseControlInput label="Zip">
        <VTextField v-model="form.zip" label="Zip" color="gold" />
      </BaseControlInput>

      <BaseControlInput label="City">
        <VTextField v-model="form.city" label="City" color="gold" />
      </BaseControlInput>

      <BaseControlInput label="State">
        <VTextField v-model="form.state" label="State" color="gold" />
      </BaseControlInput>

      <BaseControlInput label="Country">
        <VAutocomplete
          v-model="form.countryId"
          label="Country"
          color="gold"
          :items="$route.params.countries"
          item-text="name"
          item-value="id"
        />
      </BaseControlInput>

      <BaseControlInput label="Latitude">
        <VTextField v-model="form.latitude" label="Latitude" color="gold" />
      </BaseControlInput>

      <BaseControlInput label="Longitude">
        <VTextField v-model="form.longitude" label="Longitude" color="gold" />
      </BaseControlInput>

      <BaseControlInput label="Phone">
        <VTextField v-model="form.phone" label="Phone" color="gold" />
      </BaseControlInput>

      <BaseControlInput label="Star rate">
        <VAutocomplete
          v-model="form.starRate"
          label="Star rate"
          color="gold"
          :items="$route.params.starRates"
        />
      </BaseControlInput>

      <VBtn
        slot="card-actions-right"
        color="gold"
        type="submit"
        :loading="loading"
        dark
      >
        Update
      </VBtn>
    </BaseCard>
  </VForm>
</template>
